import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { ReservationCreatePage } from '../reservation-create/reservation-create';
import { ReservationsServices } from '../services';
import { ReservationManualCreatePage } from '../reservation-manual-create/reservation-manual-create';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';


@Component({
    selector: 'page-reservation-accepted-list',
    templateUrl: 'reservation-accepted-list.html',
})
export class ReservationAcceptedListPage {

    accepted_reservations: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        public reservationsServices: ReservationsServices) {

        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: ''
        });
        loadingPopup.present();
        this.acceptedReservations();
        loadingPopup.dismiss();
    }

    ionViewWillEnter() {
        this.acceptedReservations();
    }

    async acceptedReservations() {
        this.accepted_reservations = await this.reservationsServices.getReservationsByState(this.globals.restaurant_uid, 'accepted');
    }

    openReservation(reservation) {
        this.navCtrl.push(ReservationCreatePage, {
            reservation: reservation,
            update_state: true,
        });
    }

    createReservation() {
        if(this.globals.checkLimitsByLicense('reservations', 'calendar')) {
            this.navCtrl.push(ReservationManualCreatePage);
          } else{
            this.navCtrl.push(AddonsTriggerVersionProPage);
          }     }

}



// WEBPACK FOOTER //
// ./src/pages/reservation/reservation-accepted-list/reservation-accepted-list.ts